import axios from 'axios';
import humps from 'humps';
import Serializer from '@contently/simple-json-api-resource-seralizer';

const transform = data => {
  const mapper = new Serializer();
  return mapper.deserialize(data);
};

const transformRequest = [data => humps.decamelizeKeys(data), ...axios.defaults.transformRequest];

window.env = window.env || {};

const axiosInstance = axios.create({
  baseURL: window.env.CONTENTLY_BASE_URL,
  transformRequest
});

axiosInstance.interceptors.response.use(
  res => {
    return { ...res, data: transform(res.data) };
  },
  error => {
    const {
      response: {
        data,
        status,
        statusText,
        config: { url }
      }
    } = error;

    if (window.env.ENV !== 'development') {
      window.Honeybadger.notify(error, 'API Error', {
        context: {
          url,
          status,
          statusText
        }
      });
    }
    const customError = new Error(statusText);
    customError.message = data;
    customError.status = status;
    throw customError;
  }
);

export default axiosInstance;
